import { useTranslation } from "react-i18next";
import { NeuCard } from "../../components/neu/Neu";
import { useAuth } from "../../context/AuthContext";
import { useEnsureAvatar } from "../../hooks/useEnsureAvatar";
import { initials } from "../../utils/initials";

export const ProfileCard = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  useEnsureAvatar();

  return (
    <NeuCard className="p-5 sm:p-6" data-testid="profile-card">
      <div className="flex items-center gap-4">
        <div className="min-w-0 flex-1 text-start" data-testid="profile-info">
          <p className="truncate text-xl font-extrabold">{user?.name}</p>
          <p className="mt-0.5 truncate text-sm text-muted-foreground">
            <span dir="ltr">{user?.email}</span>
          </p>
          <p className="mt-1 text-sm font-semibold text-primary">{t(`roles.${user?.role}`)}</p>
        </div>
        <div
          className="flex h-20 w-20 shrink-0 items-center justify-center overflow-hidden rounded-full bg-background text-primary shadow-neu-sm"
          data-testid="avatar-preview"
        >
          {user?.avatar ? (
            <img src={user.avatar} alt={user?.name} className="h-full w-full object-cover" />
          ) : (
            <span className="text-xl font-black" data-testid="avatar-initials">{initials(user?.name)}</span>
          )}
        </div>
      </div>
    </NeuCard>
  );
};
